var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "wizardstepjobmatchemailnotification d-flex align-items-center flex-column",
    },
    [
      _c(
        "div",
        {
          staticClass:
            "col-sm-12 col-md-6 col-lg-5 flex-column d-flex p-0 mb-5",
        },
        [
          _c("ButtonWithCheckMark", {
            attrs: {
              active: _vm.notificationLevel === "Daily",
              title: _vm.wizardstep.daily,
              disable: _vm.email === "",
            },
            on: {
              emitClick: function ($event) {
                return _vm.setNotificationLevel("Daily")
              },
            },
          }),
          _c("ButtonWithCheckMark", {
            attrs: {
              active: _vm.notificationLevel === "TwiceWeekly",
              title: _vm.wizardstep.twiceWeek,
              disable: _vm.email === "",
            },
            on: {
              emitClick: function ($event) {
                return _vm.setNotificationLevel("TwiceWeekly")
              },
            },
          }),
          _c("ButtonWithCheckMark", {
            attrs: {
              active: _vm.notificationLevel === "Weekly",
              title: _vm.wizardstep.weekly,
              disable: _vm.email === "",
            },
            on: {
              emitClick: function ($event) {
                return _vm.setNotificationLevel("Weekly")
              },
            },
          }),
          _c("ButtonWithCheckMark", {
            attrs: {
              active: _vm.notificationLevel === "NoNotification",
              title: _vm.wizardstep.noNotifications,
            },
            on: {
              emitClick: function ($event) {
                return _vm.setNotificationLevel("NoNotification")
              },
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass:
            "email-notification-info-box col-sm-12 col-md-6 col-lg-5 bg-grey-200 p-4 d-flex align-items-center flex-column text-center",
        },
        [
          _c("div", [
            _c("h6", {
              staticClass: "fw-fat mb-3",
              domProps: { innerHTML: _vm._s(_vm.wizardstep.infoBoxHeader) },
            }),
            _c("p", { domProps: { innerHTML: _vm._s(_vm.generateInfoBox()) } }),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }